<template>
    <div class="home">
        <div class="placeholder"></div>
        <div class="home-bg"> </div>
        <div class="home-swipe">
            <Swipe class="swipe" :autoplay="3000" indicator-color="white">
                <SwipeItem>
                    <img src="../../assets/img/home/swipe1.png" alt="" />
                </SwipeItem>
                    <SwipeItem>
                    <img src="../../assets/img/home/swipe1.png" alt="" />
                </SwipeItem>
            </Swipe>
        </div>
        <div class="breadcrumb">
            <div class="breadcrumb-l">
                <span class="active">{{ $t('home.ecological') }} </span>
                <span>/Ecological Node</span>
            </div>

            <div class="breadcrumb-r">
                <span @click="goNode()">{{ $t('home.more') }}</span>
                <img src="../../assets/img/home/arrow.png" alt="" />
            </div>
        </div>

        <div class="card" v-for="(item,i) in listnode" :key="i">
            <div>
                <div class="card-l">
                    <img :src="getImg(i)" alt="" />
                </div>
                <div class="card-r">
                    <div class="card-r-l">
                        <div>{{ getNodeName(i) }}</div>
                        <div>$ {{item.price}}</div>
                        <div class="card-r-l-b">
                            <span>{{ $t('home.limited') }} {{item.count - item.usecount}} {{ $t('home.mat') }}</span>
                        </div>
                    </div>
                    <div class="card-r-r">
                        <div class="text">
                            {{ $t('home.lock') }}:<span>{{Number(item.daybfb)/10}}%/30{{ $t('home.sky') }}</span>
                        </div>
                        <div class="btn" @click="buyNode(i)" >{{ $t('home.subscription') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="card">
            <div>
                <div class="card-l">
                    <img src="../../assets/img/home/icon2.png" alt="" />
                </div>
                <div class="card-r">
                    <div class="card-r-l">
                        <div>{{ $t('home.gold') }}</div>
                        <div>$ 5000</div>
                        <div class="card-r-l-b">
                            <span>{{ $t('home.limited') }}  XX {{ $t('home.mat') }}</span>
                        </div>
                    </div>
                    <div class="card-r-r">
                       <div class="text" >
                         {{ $t('home.lock') }}:<span>2%/30{{ $t('home.sky') }}</span>
                       </div>
                        <div class="btn" @click="buy1()">{{ $t('home.subscription') }}</div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="breadcrumb breadcrumb1">
            <div class="breadcrumb-l">
                <span class="active">{{ $t('home.application') }} </span>
                <span>/Application Scenarios</span>
            </div>

            <div class="breadcrumb-r"></div>
        </div>

        <div class="application">
            <div>
                <div>
                    <img src="../../assets/img/home/icon3.png" alt="" />
                    <div>
                        {{ $t('home.desc1') }}
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <img src="../../assets/img/home/icon4.png" alt="" />
                    <div>
                        {{ $t('home.desc2') }}

                    </div>
                </div>
            </div>


            <div>
                <div>
                    <img src="../../assets/img/home/icon5.png" alt="" />
                    <div>
                        {{ $t('home.desc3') }}

                    </div>
                </div>
            </div>


            <div>
                <div>
                    <img src="../../assets/img/home/icon6.png" alt="" />
                    <div>
                        {{ $t('home.desc4') }}

                    </div>
                </div>
            </div>


            <div>
                <div>
                    <img src="../../assets/img/home/icon7.png" alt="" />
                    <div>
                        {{ $t('home.desc5') }}

                    </div>
                </div>
            </div>


            <div>
                <div @click="goLink(0)">
                    <img src="../../assets/img/home/icon8.png" alt="" />
                    <div>
                        {{ $t('home.community') }}

                    </div>
                </div>
            </div>

        </div>


        <div class="breadcrumb ">
            <div class="breadcrumb-l">
                <span class="active"> {{ $t('home.partners') }} </span>
                <span>/Partners</span>
            </div>

            <div class="breadcrumb-r"></div>
        </div>

        <div class="partners">
            <a href="#">
                <div class="icon icon1">
                    <img src="../../assets/img/home/icon21.png" alt="">
                </div>
                <div>JuCoin</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon10.png" alt="">
                </div>
                <div>Binance</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon11.png" alt="">
                </div>
                <div>OKX</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon12.png" alt="">
                </div>
                <div>Huobi</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon13.png" alt="">
                </div>
                <div>Gate.io</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon14.png" alt="">
                </div>
                <div>Bybit</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon15.png" alt="">
                </div>
                <div>KuCoin</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon16.png" alt="">
                </div>
                <div>MEXC</div>
            </a>

            <a href="#">
                <div class="icon">
                    <img src="../../assets/img/home/icon17.png" alt="">
                </div>
                <div>Bitget</div>
            </a>
        </div>

        <div class="breadcrumb ">
            <div class="breadcrumb-l">
                <span class="active">{{ $t('home.contact') }} </span>
                <span>/Contact Us</span>
            </div>

            <div class="breadcrumb-r"></div>
        </div>

        <div class="contact">
            <div>
                <img src="../../assets/img/home/icon18.png" alt="">
                <div>
                    Telegram
                </div>
            </div>

            <div>
                <img src="../../assets/img/home/icon19.png" alt="">
                <div>
                    Twitter
                </div>
            </div>

            <div>
                <img src="../../assets/img/home/icon20.png" alt="">
                <div>
                    Facebook
                </div>
            </div>
        </div>


             <Popup v-model="subscriptionShow" position="bottom" round get-container="#app">
            <!-- <div v-if="!subscriptionLoading && !subscriptionOk" class="subscription-popup">
                <div class="title">
                    {{ $t('node.nodeSubscription') }}
                    <img src="../../assets/img/node/icon7.png" @click="subscriptionShow = false" alt="">
                </div>
                <div class="value">
                    5000<span>USDT</span>
                </div>


                <div class="desc">
                   <div>
                     <div>
                        <div class="label">{{ $t('node.receivedTo') }}</div>
                        <div class="value">0x2415a...c6aaec61bf4d</div>
                    </div>

                    <div>
                        <div class="label">{{ $t('node.networkFee') }}</div>
                        <div class="value">0.00032 BNB</div>
                    </div>

                    <div>
                        <div class="label">{{ $t('node.nonce') }}</div>
                        <div class="value">7</div>
                    </div>
                   </div>
                </div>
                <div class="btn" @click="handleSubscription">
                    {{ $t('node.confirmSubscription') }}
                </div>
            </div>
            <div class="subscription-loading" v-if="subscriptionLoading">
                <div class="title">
                    {{ $t('node.progress') }}
                    <img src="../../assets/img/node/icon7.png" @click="subscriptionShow = false" alt="">
                </div>
                <div class="loading">
                    <div class="loader-inner ball-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="desc"> {{ $t('node.progress') }}
                </div>
            </div> -->
            <div class="subscription-claim" >
                <div class="title">
                    {{ $t('node.executionSuccessful') }}
                    <img src="../../assets/img/node/icon7.png" @click="subscriptionShow = false" alt="">
                </div>
                <div class="claim-ok">
                    <img src="../../assets/img/node/claim.png" alt="">
                    <div class="title">
                        {{ $t('node.executionSuccessful') }}
                    </div>
                    <!-- <div class="desc">
                        <span>{{ $t('node.at') }}Nexus Chain {{ $t('node.view') }}:0xe7d92</span>
                        <img src="../../assets/img/node/icon8.png" alt="">
                    </div> -->
                </div>

            </div>
        </Popup>
    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";


import axios from 'axios'
import Web3 from 'web3'
import contractaa from '../contract/index.js'
let web3
web3 = new Web3(window.ethereum)

export default {
    name: "home",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "",
            subscriptionLoading: false,
            subscriptionShow: false,
            subscriptionOk: false,
            listnode:[],
            iscanlink:false,
        };
    },

    methods: {
        handleSubscription() {

            this.$toast.fail("错误提示");
            return;

            this.subscriptionLoading = true;
            setTimeout(() => {
                this.subscriptionOk = true;
                this.subscriptionLoading = false;

            }, 2000)
        },
        onSubscriptionClose() {
            this.$toast.fail("错误提示");
            return;
            this.subscriptionLoading = false;
            this.subscriptionShow = false;
            this.subscriptionOk = false;

        },
        goNode(){
            this.$router.push({
                name: 'node'
            });
        },
        async goLink(v){

            if(this.iscanlink){
                this.$router.push({name: 'release'});
            }


            
        },
        getImg(v){
            if(v==0){
               return require('../../assets/img/home/icon1.png')
            }else if(v==1){
                return require('../../assets/img/home/icon2.png')
            }
        },
        async getInfo(){
            //this.listnode = [{price:3,count:0,usecount:0},{price:4,count:10,usecount:1}]
            let that = this;
            let address = this.$store.state.globalAddress;
            let NodeContract = new web3.eth.Contract(contractaa.abiNode,contractaa.nodeToken);
            await NodeContract.methods.getNodeList().call({from:address}).then(function(result){
                var _result = result;
                that.listnode = _result.slice(0,2);
                for(var i=0;i<2;i++){
                    that.listnode[i].price = web3.utils.fromWei(_result[i].price,'ether')
                }
            })


            var KOLContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.KOLToken);
            //var AirdropContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.AirdropToken);
            var LiquidityContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.LiquidityToken);
            var TeamFundContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.TeamFundToken);
            var EcoFundContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.EcoFundToken);
            var InvestmentContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.InvestmentToken);
            var NodeReleaseContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.NodeReleaseToken);
            //var MiningContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.MiningToken);
            var StakingContract = new web3.eth.Contract(contractaa.abiRelease,contractaa.StakingToken);

            const isKOLRelease = await KOLContract.methods.userIsRelease(address).call({ from: address });
            if(isKOLRelease){
                that.iscanlink = true;
            }
            if(that.iscanlink){return}
            // const isAirdropRelease = await AirdropContract.methods.userIsRelease(address).call({ from: address });
            // if(isAirdropRelease){
            //     that.iscanlink = true;
            // }
            if(that.iscanlink){return}
            const isLiquidityRelease = await LiquidityContract.methods.userIsRelease(address).call({ from: address });
            if(isLiquidityRelease){
                that.iscanlink = true;
            }
            if(that.iscanlink){return}

            const isTeamFundRelease = await TeamFundContract.methods.userIsRelease(address).call({ from: address });
            if(isTeamFundRelease){
                that.iscanlink = true;
            }
            if(that.iscanlink){return}

            const isEcoFundRelease = await EcoFundContract.methods.userIsRelease(address).call({ from: address });
            if(isEcoFundRelease){
                that.iscanlink = true;
            }
            if(that.iscanlink){return}

            const isInvestmentRelease = await InvestmentContract.methods.userIsRelease(address).call({ from: address });
            if(isInvestmentRelease){
                that.iscanlink = true;
            }
            if(that.iscanlink){return}

            const isNodeReleaseRelease = await NodeReleaseContract.methods.userIsRelease(address).call({ from: address });
            if(isNodeReleaseRelease){
                that.iscanlink = true;
            }
            if(that.iscanlink){return}

            // const isMiningRelease = await MiningContract.methods.userIsRelease(address).call({ from: address });
            // if(isMiningRelease){
            //     that.iscanlink = true;
            // }
            if(that.iscanlink){return}

            const isStakingRelease = await StakingContract.methods.userIsRelease(address).call({ from: address });
            if(isStakingRelease){
                that.iscanlink = true;
            }
            if(that.iscanlink){return}

        },
        // buyNode(){
        //     //展示交易执行中
        //     //this.$store.commit('handleShow', true)
        //     //交易成功提示
        //     //this.subscriptionShow = true;
          

            
        // },
        async buyNode(v){
            console.log(v);

            let that = this;
            let address = this.$store.state.globalAddress;
            var UsdtContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.usdtToken);
            var NodeContract = new web3.eth.Contract(contractaa.abiNode,contractaa.nodeToken);
            let _amount;
            let _yCount;
            await NodeContract.methods.nodeList(v).call({from:address}).then(function(result){
                _amount = web3.utils.fromWei(result[0],'ether');
                _yCount = Number(result[4]) - Number(result[5])
            }) 

            console.log(_yCount);
            if(_yCount<=0){
                that.$toast.fail(that.$t('node.nocount'));
                return;
            }
            that.$store.commit('handleShow', true)
            let maxmunber = '115792089237316195423570985008687907853269984665640564039457584007913129639935';

            UsdtContract.methods.allowance(address,contractaa.nodeToken).call({from:address}).then(function(result){
                //获取 result 授权数量
                let dd = web3.utils.fromWei(result,'ether')
                //console.log('授权数量'+dd);
                if(dd >= _amount){
                    NodeContract.methods.buyNode(v).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            axios.get(contractaa.APIURL+'?cmd=buynode&re=0&tx='+receipt.transactionHash).then(function (response) {
                            if (response.status === 200) {
                                    console.log("axios:"+response.data.Message)
                                }
                            })
                            //that.$message.success("操作成功");
                            that.$store.commit('handleLoading', false)
                            //that.subscriptionShow = true;
                            that.getInfo();
                        } else {
                            that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }else{
                    UsdtContract.methods.approve(contractaa.nodeToken,maxmunber).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            NodeContract.methods.buyNode(v).send({from:address}).then(receipt => {
                                    //监听后续的交易情况
                                    if (receipt.status == "1") {
                                        axios.get(contractaa.APIURL+'?cmd=buynode&re=0&tx='+receipt.transactionHash).then(function (response) {
                                        if (response.status === 200) {
                                                console.log("axios:"+response.data.Message)
                                            }
                                        })

                                        that.$store.commit('handleLoading', false)
                                        that.getInfo();
                                        //that.subscriptionShow = true;
                                       
                                    } else {
                                        that.$toast.fail(that.$t('node.error'));
                                    }          
                                });

                        } else {
                           that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }
            })  
        },
    },
    computed: {
        nodeMap() {
            return {
                0: this.$t('node.node0'),
                1: this.$t('node.node1'),
            };
        },
        getNodeName(){
            return(v)=>{
                if(v==0){
                    return this.$t('node.node0')
                }else if(v==1){
                    return this.$t('node.node1')
                }
            }
        }
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.home {
    position: relative;
    // overflow-x: hidden;

    // height: 100%;
    background-size: 100% 800px;
    padding: 0 16px 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;

    &-bg {
        width: 375px;
        position: absolute;
        height: 178px;
        top: -44px;
        background: url('../../assets/img/layout/bg.png') no-repeat center;
        background-size: 100% 100%;
    }

    .placeholder {
        height: 34px;
    }

    .px15 {
        padding: 0 15px;
    }

    .home-swipe {
        margin-top: 24px;

        padding: 0 1px;
        margin-bottom: 32px;

        .swipe {
            border-radius: 16px;
        }
    }

    .breadcrumb {
        font-size: 12px;
        line-height: 12px;
        display: flex;
        align-items: center;
        color: #FFFFFF;

        span {
            opacity: 0.6;
        }

        .active {
            font-weight: bold;
            font-size: 16px;
            line-height: 16px;
            opacity: 1;
        }

        display: flex;
        justify-content: space-between;

        &-r {
            display: flex;
            align-items: center;

            img {
                margin-left: 4px;
                width: 16px;
                height: 16px;
            }
        }
    }

    .card {
        margin-top: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            display: flex;
            justify-content: space-between;
            padding: 14px 12px;
        }


        &-l {
            height: 88px;
            width: 88px;
            border-radius: 8px;
            background: url('../../assets/img/home/icon-bg.png')no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;

        }

        &-r {
            margin-left: 12px;
            flex: 1;
            padding-top: 8px;
            padding-bottom: 2px;
            display: flex;
            color: #FFFFFF;

            &-l {
                flex: 1;
                font-size: 16px;
                line-height: 16px;

                >div {
                    margin-bottom: 15px;
                }

                &-b {
                    margin-top: 19px;
                    line-height: 12px;
                    font-weight: 500;
                    font-size: 12px;
                    opacity: 0.6;
                    margin-bottom: 0 !important;
                }
            }

            &-r {
                padding: 2px 0;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;

                .text {
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 500;
                    max-width: 120px;
                    text-align: right;
                    span {
                        background-image: -webkit-linear-gradient(134deg, #0DF1D5 2%, #0190D1 98%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }

                .btn {
                    width: 76px;
                    height: 32px;
                    cursor: pointer;
                    border-radius: 8px;
                    font-size: 14px;
                    display: flex;
                    color: #000000;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(112deg, #0DF1D5 0%, #0190D1 97%);
                }
            }
        }
    }

    .breadcrumb1 {
        margin-top: 32px;
    }

    .application {
        margin-top: 16px;
        margin-bottom: 36px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        >div {
            width: 101px;
            min-height: 110px;
            background: #fffcf5;
            border-radius: 16px;
            background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 22px;
            box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);

            >div {
                width: calc(100% - 2px);
                border-radius: 16px;
                height: calc(100% - 2px);
                padding: 0 10px 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background: linear-gradient(210deg, #1E1D24 4%, #13121B 91%);

                >img {
                    width: 44px;
                    height: 44px;
                }

                >div {
                    font-size: 10px;
                    line-height: 14px;
                    text-align: center;
                    margin-top: 10px;
                    color: #fff;
                }
            }
        }
    }

    .partners {
        margin-top: 21px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 16px;

        >a {
            margin-bottom: 20px;

            .icon {
                width: 104px;
                height: 46px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: url('../../assets/img/home/card-bg1.png') no-repeat;
                background-size: 100% 100%;
                overflow: hidden;
                border-radius: 8px;
                opacity: 1;

                >img {
                    width: 92px;
                    height: 46px;
                }
            }

            .icon1>img {
                width: 90px;
                height: 17px;
            }

            >div {
                margin-top: 8px;
                text-align: center;
                opacity: 0.7;
                font-family: Alibaba PuHuiTi 3.0;
                font-size: 14px;
                line-height: 14px;
                color: #FFFFFF;
            }
        }
    }

    .contact {
        margin-top: 16px;
        background: url('../../assets/img/home/card-bg.png') no-repeat;
        background-size: 100% 100%;
        display: flex;
        height: 94px;

        >div {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 19px;

            img {
                width: 32px;
                height: 32px;
            }

            >div {
                margin-top: 14px;
                font-family: Alibaba PuHuiTi 3.0;
                font-size: 14px;
                line-height: 14px;
                color: #FFFFFF;
            }
        }
    }
}
</style>
<style lang="less">
.home {
    .home-swipe {
        .swipe .van-swipe-item {
            color: #fff;
            font-size: 20px;
            height: 160px;
            text-align: center;
        }
    }
    .van-swipe__indicators {
        right: 12px;
        bottom: 12px;
        left: auto;
    }
}
</style>